<template>
  <div class="dashboard-container">
    <!-- 右侧内容区域 -->
    <div class="content">
      <!-- 药品统计 -->
      <div  class="report-container">
        <div class="report-header">
          <div class="header-title">
            <i class="el-icon-first-aid-kit report-icon"></i>
            <span class="report-title">诊所药品统计报表</span>
          </div>
          <div class="header-toolbar">
            <el-date-picker
                size="mini"
                v-model="drugTimeRange"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="loadDrugData"
                :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>

        <div class="report-table">
          <el-table
              :data="drugTableData"
              border
              :row-class-name="drugTableRowClassName"
              style="width: 100%"
              class="report-data-table">
            <el-table-column
                v-for="(col, index) in drugTableColumns"
                :key="index"
                :prop="col.prop"
                :label="col.label"
                :min-width="col.width"
                align="center"
                header-align="center">
              <template #default="{ row }">
                <span v-if="col.type === 'amount'">{{ formatAmount(row[col.prop]) }}</span>
                <span v-else-if="col.prop === 'type'">{{ formatDrugType(row[col.prop]) }}</span>
                <span v-else>{{ row[col.prop] || ' ' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDoctorsStatistics, getDrugStatistics, getFinance} from "@/api/statisticalReport/statisticalReport";
import dayjs from "dayjs";
import {
  getWesternMedicineStaticsPage,
  getWestRelatedMedicalOrders
} from "@/api/westernMedicineList/westernMedicineList";
import OutpatientChargeStatistics from '@/views/outpatientChargeStatistics/outpatientChargeStatistics.vue';
import {getAllFinanceclass, getFinanceclassList} from "@/api/clasificacionContable/clasificacionContable";
import financialDetails from "@/views/financialDetails/financialDetails.vue";

export default {
  name: 'StatisticalStatement',
  components: {
    // 注册门诊收费统计组件
    OutpatientChargeStatistics,
    financialDetails
  },
  data() {
    return {
      fieldConfigs: [
        {key: 'chmedAmt', name: '中草药'},
        {key: 'diagnosAmt', name: '诊察'},
        {key: 'medAmt', name: '西药'},
        {key: 'medMaterialAmt', name: '医用卫材'},
        {key: 'regAmt', name: '挂号'},
        {key: 'treatAmt', name: '治疗'}
      ],
      spanArr: [],
      westRelatedMedicalOrdersData: [],
      westRelatedMedicalOrdersRows: [
        {prop: '序号', label: 'id'},
        {prop: '医嘱内容', label: 'content'},
        {prop: '成本金额', label: 'costPric'},
        {prop: '金额', label: 'price'},
      ],
      currentComponent: 'doctorStatistics',

      // 医生统计相关数据
      doctorTimeRange: [
        dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      ],
      doctorTableData: [],
      doctorTableColumns: [
        {prop: 'doctorId', label: '医生序号', width: 100},
        {prop: 'doctorNmae', label: '医生姓名', width: 120},
        {prop: 'drxNum', label: '处方数量', width: 100},
        {prop: 'avgAmount', label: '次均费用', width: 100, type: 'amount'},
        {prop: 'avgMcAmount', label: '次均药费', width: 100, type: 'amount'},
        {prop: 'avgTreatAmount', label: '次均诊疗费', width: 120, type: 'amount'},
        {prop: 'mcAmount', label: '药品金额', width: 100, type: 'amount'},
        {prop: 'mcProportion', label: '药占比', width: 100},
        {prop: 'opNum', label: '门诊人次', width: 100},
        {prop: 'totalAmount', label: '总金额', width: 100, type: 'amount'},
        {prop: 'treatAmount', label: '诊疗金额', width: 100, type: 'amount'}
      ],

      // 财务统计相关数据
      financeTimeRange: [
        dayjs().startOf('month').format('YYYY-MM-DD 00:00:00'),
        dayjs().endOf('month').format('YYYY-MM-DD 23:59:59')
      ],
      financeData: {},
      financeDataNoCondition: {},

      // 药品统计相关数据
      drugTimeRange: [
        dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      ],
      drugTableData: [],
      drugTableColumns: [
        {prop: 'drugId', label: '药品序号', width: 100},
        {prop: 'drugName', label: '药品名称', width: 150},
        {prop: 'type', label: '类型', width: 100},
        {prop: 'cnt', label: '数量', width: 100},
        {prop: 'purcAmt', label: '成本金额', width: 100, type: 'amount'},
        {prop: 'saleAmt', label: '零售金额', width: 100, type: 'amount'}
      ],

      // 时间选择器配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      feeClassMap: {
        0: '其他费用',
        1: '办公用品费',
        2: '水电费',
        3: '房租费',
        4: '物业费',
        5: '差旅费',
        6: '通讯费',
        7: '培训费',
        8: '会议费',
        9: '招待费',
        10: '维修费',
        11: '折旧费',
        12: '工资福利费',
        13: '社保公积金',
        14: '税费'
      },
      // 导航菜单 - 简化财务统计结构
      menuTree: [
        {
          label: '医生统计',
          component: 'doctorStatistics',
          icon: 'el-icon-user'
        },
        {
          label: '财务统计',
          component: 'finance_all', // 修改为统一的财务统计
          icon: 'el-icon-money'
        },
        {
          label: '药品统计',
          component: 'pharmaceuticalStatistics',
          icon: 'el-icon-first-aid-kit'
        },
        {
          label: '西药处方统计',
          component: 'westernDrugPrescriptionStats',
          icon: 'el-icon-document'
        },
        {
          label: '门诊收费统计',  // 新增的树节点
          component: 'outpatientChargeStatistics',
          icon: 'el-icon-money'
        },
        {
          label: '资金明细统计',
          component: 'financialDetails',
          icon: 'el-icon-money'
        },
      ],
      treeProps: {
        label: 'label',
        children: 'children'
      },

      // 西药处方统计相关数据
      westernDrugTimeRange: [],
      westernDrugTableData: [],
      westernDrugQuery: {
        bilgDeptId: null,
        bilgDrId: null,
        state: null,
      },
      doctorOptions: [],
      deptOptions: [],
      financeclassOptions: [],
      /*状态 0:草稿 1:已收费 2:已配药 3: 已发药 4:待退费 5:已退药 6:已作废*/
      stateOptions: [{id: 0, label: '草稿'}, {id: 1, label: '已收费'}, {id: 2, label: '已配药'}
        , {id: 3, label: '已发药'}, {id: 4, label: '待退费'}, {id: 5, label: '已退药'}, {
          id: 6,
          label: '已作废'
        }, {id: 7, label: '已退费'}
      ],
      westernDrugLoading: false,
      westernDrugPageNum: 1,
      westernDrugPageSize: 8,
      westernDrugTotalSize: 0,
      westernDrugTableColumns: [
        {prop: 'rxNo', label: '处方序号', width: 120},
        {prop: 'bilgDeptId', label: '处方科室', width: 120},
        {prop: 'bilgDrId', label: '处方医生', width: 120},
        {prop: 'retFlag', label: '退药标识', width: 100},
        {prop: 'purcAmt', label: '成本金额', width: 100},
        {prop: 'saleAmt', label: '合计金额', width: 100},
        {prop: 'grossMargin', label: '毛利', width: 100},
        {prop: 'costPric', label: '关联处置成本金额', width: 140},
        {prop: 'pric', label: '关联处置金额', width: 120},
        {prop: 'reAmt', label: '退药金额', width: 100},
        {prop: 'state', label: '状态', width: 100}
      ],

      associatedDisposalTableColumns: [
        {prop: 'content', label: '医嘱内容'},
        {prop: 'pric', label: '金额'},
        {prop: 'costPric', label: '成本金额'},
      ],
    }
  },
  computed: {
    grossProfit() {
      return this.saleIncomeTotal - this.saleExpenseTotal;
    },
    // 生成ERP表格数据
    erpTableData() {
      const currentIncomeData = this.financeData.saleIncomRespVO || {};
      const currentExpenseData = this.financeData.saleExpensesRespVO || {};
      const currentManageFeeData = this.financeData.manageFeeResp || [];
      const cumulativeIncomeData = this.financeDataNoCondition.saleIncomRespVO || {};
      const cumulativeExpenseData = this.financeDataNoCondition.saleExpensesRespVO || {};
      const cumulativeManageFeeData = this.financeDataNoCondition.manageFeeResp || [];

      // 计算各项合计
      const currentIncomeTotal = Object.values(currentIncomeData).reduce((sum, val) => sum + (val || 0), 0);
      const currentExpenseTotal = Object.values(currentExpenseData).reduce((sum, val) => sum + (val || 0), 0);
      const currentManageFeeTotal = currentManageFeeData.reduce((sum, item) => sum + (item.amount || 0), 0);
      const cumulativeIncomeTotal = Object.values(cumulativeIncomeData).reduce((sum, val) => sum + (val || 0), 0);
      const cumulativeExpenseTotal = Object.values(cumulativeExpenseData).reduce((sum, val) => sum + (val || 0), 0);
      const cumulativeManageFeeTotal = cumulativeManageFeeData.reduce((sum, item) => sum + (item.amount || 0), 0);

      // 总支出 = 主营业务支出 + 管理费用
      const currentTotalExpense = currentExpenseTotal + currentManageFeeTotal;
      const cumulativeTotalExpense = cumulativeExpenseTotal + cumulativeManageFeeTotal;

      return [
        // ============ 【收入】部分 ============
        {
          name: '【收入】',
          currentAmount: currentIncomeTotal,
          cumulativeAmount: cumulativeIncomeTotal,
          totalAmount: currentIncomeTotal + cumulativeIncomeTotal,
          rowType: 'section-title',
          rowClass: 'section-title-row income-section',
          currentAmountClass: 'section-title-amount income-section-amount',
          cumulativeAmountClass: 'section-title-amount income-section-amount',
          totalAmountClass: 'section-title-amount income-section-amount'
        },

        {
          name: '主营业务收入',
          currentAmount: currentIncomeTotal,
          cumulativeAmount: cumulativeIncomeTotal,
          totalAmount: currentIncomeTotal + cumulativeIncomeTotal,
          rowType: 'category-title',
          rowClass: 'category-title-row income-category',
          currentAmountClass: 'category-title-amount income-category-amount',
          cumulativeAmountClass: 'category-title-amount income-category-amount',
          totalAmountClass: 'category-title-amount income-category-amount'
        },

        // 收入明细项目
        {
          name: '中草药收入',
          currentAmount: currentIncomeData.chmedAmt || 0,
          cumulativeAmount: cumulativeIncomeData.chmedAmt || 0,
          totalAmount: (currentIncomeData.chmedAmt || 0) + (cumulativeIncomeData.chmedAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount income-amount',
          cumulativeAmountClass: 'detail-amount income-amount',
          totalAmountClass: 'detail-amount income-amount'
        },
        {
          name: '诊察收入',
          currentAmount: currentIncomeData.diagnosAmt || 0,
          cumulativeAmount: cumulativeIncomeData.diagnosAmt || 0,
          totalAmount: (currentIncomeData.diagnosAmt || 0) + (cumulativeIncomeData.diagnosAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount income-amount',
          cumulativeAmountClass: 'detail-amount income-amount',
          totalAmountClass: 'detail-amount income-amount'
        },
        {
          name: '西药收入',
          currentAmount: currentIncomeData.medAmt || 0,
          cumulativeAmount: cumulativeIncomeData.medAmt || 0,
          totalAmount: (currentIncomeData.medAmt || 0) + (cumulativeIncomeData.medAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount income-amount',
          cumulativeAmountClass: 'detail-amount income-amount',
          totalAmountClass: 'detail-amount income-amount'
        },
        {
          name: '医用卫材收入',
          currentAmount: currentIncomeData.medMaterialAmt || 0,
          cumulativeAmount: cumulativeIncomeData.medMaterialAmt || 0,
          totalAmount: (currentIncomeData.medMaterialAmt || 0) + (cumulativeIncomeData.medMaterialAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount income-amount',
          cumulativeAmountClass: 'detail-amount income-amount',
          totalAmountClass: 'detail-amount income-amount'
        },
        {
          name: '挂号收入',
          currentAmount: currentIncomeData.regAmt || 0,
          cumulativeAmount: cumulativeIncomeData.regAmt || 0,
          totalAmount: (currentIncomeData.regAmt || 0) + (cumulativeIncomeData.regAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount income-amount',
          cumulativeAmountClass: 'detail-amount income-amount',
          totalAmountClass: 'detail-amount income-amount'
        },
        {
          name: '治疗收入',
          currentAmount: currentIncomeData.treatAmt || 0,
          cumulativeAmount: cumulativeIncomeData.treatAmt || 0,
          totalAmount: (currentIncomeData.treatAmt || 0) + (cumulativeIncomeData.treatAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount income-amount',
          cumulativeAmountClass: 'detail-amount income-amount',
          totalAmountClass: 'detail-amount income-amount'
        },

        // 空行分隔
        {
          name: '',
          currentAmount: null,
          cumulativeAmount: null,
          totalAmount: null,
          rowType: 'spacer',
          rowClass: 'spacer-row',
          currentAmountClass: '',
          cumulativeAmountClass: '',
          totalAmountClass: ''
        },

        // ============ 【支出】部分 ============
        {
          name: '【支出】',
          currentAmount: currentTotalExpense,
          cumulativeAmount: cumulativeTotalExpense,
          totalAmount: currentTotalExpense + cumulativeTotalExpense,
          rowType: 'section-title',
          rowClass: 'section-title-row expense-section',
          currentAmountClass: 'section-title-amount expense-section-amount',
          cumulativeAmountClass: 'section-title-amount expense-section-amount',
          totalAmountClass: 'section-title-amount expense-section-amount'
        },

        // ===== 主营业务支出 =====
        {
          name: '主营业务支出',
          currentAmount: currentExpenseTotal,
          cumulativeAmount: cumulativeExpenseTotal,
          totalAmount: currentExpenseTotal + cumulativeExpenseTotal,
          rowType: 'category-title',
          rowClass: 'category-title-row expense-category',
          currentAmountClass: 'category-title-amount expense-category-amount',
          cumulativeAmountClass: 'category-title-amount expense-category-amount',
          totalAmountClass: 'category-title-amount expense-category-amount'
        },

        // 主营业务支出明细
        {
          name: '中草药支出',
          currentAmount: currentExpenseData.chmedAmt || 0,
          cumulativeAmount: cumulativeExpenseData.chmedAmt || 0,
          totalAmount: (currentExpenseData.chmedAmt || 0) + (cumulativeExpenseData.chmedAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount expense-amount',
          cumulativeAmountClass: 'detail-amount expense-amount',
          totalAmountClass: 'detail-amount expense-amount'
        },
        {
          name: '诊察支出',
          currentAmount: currentExpenseData.diagnosAmt || 0,
          cumulativeAmount: cumulativeExpenseData.diagnosAmt || 0,
          totalAmount: (currentExpenseData.diagnosAmt || 0) + (cumulativeExpenseData.diagnosAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount expense-amount',
          cumulativeAmountClass: 'detail-amount expense-amount',
          totalAmountClass: 'detail-amount expense-amount'
        },
        {
          name: '西药支出',
          currentAmount: currentExpenseData.medAmt || 0,
          cumulativeAmount: cumulativeExpenseData.medAmt || 0,
          totalAmount: (currentExpenseData.medAmt || 0) + (cumulativeExpenseData.medAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount expense-amount',
          cumulativeAmountClass: 'detail-amount expense-amount',
          totalAmountClass: 'detail-amount expense-amount'
        },
        {
          name: '医用卫材支出',
          currentAmount: currentExpenseData.medMaterialAmt || 0,
          cumulativeAmount: cumulativeExpenseData.medMaterialAmt || 0,
          totalAmount: (currentExpenseData.medMaterialAmt || 0) + (cumulativeExpenseData.medMaterialAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount expense-amount',
          cumulativeAmountClass: 'detail-amount expense-amount',
          totalAmountClass: 'detail-amount expense-amount'
        },
        {
          name: '挂号支出',
          currentAmount: currentExpenseData.regAmt || 0,
          cumulativeAmount: cumulativeExpenseData.regAmt || 0,
          totalAmount: (currentExpenseData.regAmt || 0) + (cumulativeExpenseData.regAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount expense-amount',
          cumulativeAmountClass: 'detail-amount expense-amount',
          totalAmountClass: 'detail-amount expense-amount'
        },
        {
          name: '治疗支出',
          currentAmount: currentExpenseData.treatAmt || 0,
          cumulativeAmount: cumulativeExpenseData.treatAmt || 0,
          totalAmount: (currentExpenseData.treatAmt || 0) + (cumulativeExpenseData.treatAmt || 0),
          rowType: 'detail-item',
          rowClass: 'detail-item-row',
          currentAmountClass: 'detail-amount expense-amount',
          cumulativeAmountClass: 'detail-amount expense-amount',
          totalAmountClass: 'detail-amount expense-amount'
        },

        // ===== 中间空格 =====
        {
          name: '',
          currentAmount: null,
          cumulativeAmount: null,
          totalAmount: null,
          rowType: 'spacer',
          rowClass: 'spacer-row',
          currentAmountClass: '',
          cumulativeAmountClass: '',
          totalAmountClass: ''
        },

        // ===== 管理费用 =====
        {
          name: '管理费用',
          currentAmount: currentManageFeeTotal,
          cumulativeAmount: cumulativeManageFeeTotal,
          totalAmount: currentManageFeeTotal + cumulativeManageFeeTotal,
          rowType: 'category-title',
          rowClass: 'category-title-row manage-category',
          currentAmountClass: 'category-title-amount manage-category-amount',
          cumulativeAmountClass: 'category-title-amount manage-category-amount',
          totalAmountClass: 'category-title-amount manage-category-amount'
        },

        // 管理费用明细
        ...this.getManageFeeItems(currentManageFeeData, cumulativeManageFeeData),

      ];
    },
// 收入总计（当期）
    saleIncomeTotal() {
      const data = this.financeData.saleIncomRespVO || {};
      return Object.values(data).reduce((sum, val) => sum + (val || 0), 0);
    },

    // 支出总计（当期）
    saleExpenseTotal() {
      const data = this.financeData.saleExpensesRespVO || {};
      const dataArr = this.financeData.manageFeeResp || [];
      return Object.values(data).reduce((sum, val) => sum + (val || 0), 0) + dataArr.reduce((sum, item) => sum + (item.amount || 0), 0);
    },

    // 累计收入总计
    cumulativeIncomeTotal() {
      const data = this.financeDataNoCondition.saleIncomRespVO || {};
      return Object.values(data).reduce((sum, val) => sum + (val || 0), 0);
    },

    // 累计支出总计
    cumulativeExpenseTotal() {
      const data = this.financeDataNoCondition.saleExpensesRespVO || {};
      return Object.values(data).reduce((sum, val) => sum + (val || 0), 0);
    },

    // 当期毛利润
    currentGrossProfit() {
      return this.saleIncomeTotal - this.saleExpenseTotal;
    },

    // 累计毛利润
    cumulativeGrossProfit() {
      return this.cumulativeIncomeTotal - this.cumulativeExpenseTotal;
    },

    // 总毛利润（当期+累计）
    totalGrossProfit() {
      return this.currentGrossProfit + this.cumulativeGrossProfit;
    },

    // 净收入
    netIncome() {
      return this.saleIncomeTotal - this.saleExpenseTotal;
    },

    manageFeeList() {
      return this.financeData.manageFeeResp || [];
    },

    // 管理费用总计
    manageFeeTotal() {
      const data = this.manageFeeList;
      return data.reduce((sum, item) => sum + (item.amount || 0), 0);
    },
    // 当前财务标题
    currentFinanceTitle() {
      const titleMap = {
        'finance_income': '收入统计报表',
        'finance_expense': '支出统计报表'
      };
      return titleMap[this.currentComponent] || '财务统计报表';
    },
  },
  mounted() {
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'];
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'];
    this.loadDoctorData();
    this.getFinanceclassList();
    this.loadDrugData();
  },
  methods: {
    // 获取管理费用明细项
    getManageFeeItems(currentData, cumulativeData) {
      const items = [];

      currentData.forEach((item, index) => {
        const cumulativeItem = cumulativeData[index] || {};
        const classId = item.classId;

        // 根据classId查找对应的label
        const classInfo = this.financeclassOptions.find(option => option.id === classId);
        const feeName = classInfo ? classInfo.label : `费用ID:${classId}`;

        items.push({
          name: feeName,
          currentAmount: item.amount || 0,
          cumulativeAmount: cumulativeItem.amount || 0,
          totalAmount: (item.amount || 0) + (cumulativeItem.amount || 0),
          rowType: 'manage-detail-item',  // 使用 manage-detail-item 类型
          rowClass: 'manage-detail-row',
          currentAmountClass: 'detail-amount manage-amount',
          cumulativeAmountClass: 'detail-amount manage-amount',
          totalAmountClass: 'detail-amount manage-amount',
          textAlign: 'right',  // 项目名称靠右
          amountAlign: 'right'  // 金额靠右
        });
      });

      return items;
    },
    async loadFinanceClassData() {
      try {
        const res = await getFinanceclassList()
        if (res && res.children) {
          this.financeClassCascaderOptions = this.processFinanceClassForCascader(res.children)
        }
      } catch (error) {
        console.error('加载财务分类失败:', error)
      }
    },
    // 计算毛利率
    calculateProfitRate() {
      if (this.saleIncomeTotal === 0) return '0.00%';
      const rate = (this.grossProfit / this.saleIncomeTotal) * 100;
      return rate.toFixed(2) + '%';
    },

    formatAmount(amount) {
      if (amount === null || amount === undefined) return '';
      if (typeof amount !== 'number') amount = parseFloat(amount) || 0;
      return amount.toFixed(2); // 保留4位小数，符合你的数据格式
    },

    // 表格行类名
    tableRowClassName({row}) {
      return row.rowType || '';
    },

    // 单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      const styles = {};

      // 项目列
      if (columnIndex === 0) {
        if (row.rowType === 'section-title' || row.rowType === 'category-title') {
          // 【收入】、【支出】、主营业务收入、主营业务支出、管理费用标题 居中
          styles.textAlign = 'center';
          styles.fontWeight = 'bold';
          styles.fontSize = row.rowType === 'section-title' ? '15px' : '14px';
          styles.padding = '8px 6px';
        } else if (row.rowType === 'detail-item' || row.rowType === 'manage-detail-item') {
          // 明细字段项目名称靠右
          styles.textAlign = 'right';
          styles.padding = '6px 10px 6px 6px';
          styles.fontWeight = 'normal';
          styles.fontSize = '13px';
        } else {
          // 其他行
          styles.textAlign = 'center';
          styles.padding = '4px';
        }
      }

      // 金额列（第1-3列）
      if (columnIndex >= 1 && columnIndex <= 3) {
        styles.fontFamily = 'Arial, sans-serif';
        styles.fontSize = '13px';

        // 判断是否为标题行
        if (row.rowType === 'section-title' || row.rowType === 'category-title') {
          // 标题行金额居中
          styles.textAlign = 'center';
          styles.padding = '8px 15px 8px 10px';
          styles.fontWeight = 'bold';
        } else if (row.rowType === 'detail-item' || row.rowType === 'manage-detail-item') {
          // 明细字段金额靠右
          styles.textAlign = 'right';
          styles.padding = '6px 15px 6px 10px';
          styles.fontWeight = 'normal';
        } else {
          // 其他行居中
          styles.textAlign = 'center';
          styles.padding = '4px';
        }
      }

      return styles;
    },
    // 表头样式
    headerCellStyle({ columnIndex }) {
      const styles = {
        background: '#409EFF',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '13px',
        padding: '10px 6px'
      };

      // 项目列表头居中，金额列表头右对齐
      if (columnIndex === 0) {
        styles.textAlign = 'center';
      } else {
        styles.textAlign = 'right';
      }

      return styles;
    },

    async getFinanceclassList() {
      const res = await getFinanceclassList({status: 1});
      this.financeclassOptions = res.map(item => {
        return {
          id: item.id, label: item.name
        }
      })
    },
    async loadChildData() {
      const res = await getWestRelatedMedicalOrders();
      if (res.code === 200) {
        this.westRelatedMedicalOrdersData = res.daga;
      } else {
        this.$message.error(res.message);
      }
    },
    // 加载西药处方统计数据
    async loadWesternDrugData() {
      try {
        this.westernDrugLoading = true;
        const params = {
          startTime: this.westernDrugTimeRange ? this.westernDrugTimeRange[0] : '',
          endTime: this.westernDrugTimeRange ? this.westernDrugTimeRange[1] : '',
          pageNum: this.westernDrugPageNum,
          pageSize: this.westernDrugPageSize,
          state: this.westernDrugQuery.state ?? null,
          bilgDeptId: this.westernDrugQuery.bilgDeptId ?? null,
          bilgDrId: this.westernDrugQuery.bilgDrId ?? null,
        };

        const res = await getWesternMedicineStaticsPage(params);
        if (res.code === 200) {
          if (res.code === 200) {
            this.westernDrugTableData = res.data?.content.map(item => ({
              ...item,
              grossMargin: (Number(item.saleAmt) - Number(item.purcAmt)).toFixed(2)
            })) || [];
            this.westernDrugTotalSize = res.data?.totalSize || 0;

            // 处理每个对象中的数组累加
            this.westernDrugTableData.forEach(item => {
              if (item.relatedDoctorAdviceRespVOS && Array.isArray(item.relatedDoctorAdviceRespVOS)) {
                // 累加 costPric
                item.costPric = item.relatedDoctorAdviceRespVOS.reduce((sum, subItem) => {
                  return sum + (parseFloat(subItem.costPric) || 0);
                }, 0);

                // 累加 price
                item.price = item.relatedDoctorAdviceRespVOS.reduce((sum, subItem) => {
                  return sum + (parseFloat(subItem.price) || 0);
                }, 0);
              }
            });
          }
        } else {
          this.$message.error(res.message || '获取西药处方统计数据失败');
        }
      } catch (error) {
        this.$message.error("系统异常: 请联系管理员");
      } finally {
        this.westernDrugLoading = false;
      }
    },

    // 西药处方统计分页处理
    handleWesternDrugSizeChange(val) {
      this.westernDrugPageSize = val;
      this.westernDrugPageNum = 1;
      this.loadWesternDrugData();
    },

    handleWesternDrugCurrentChange(val) {
      this.westernDrugPageNum = val;
      this.loadWesternDrugData();
    },

    // 西药处方状态格式化
    formatWesternDrugState(state) {
      const stateMap = {
        0: '草稿',
        1: '已收费',
        2: '已配药',
        3: '已发药',
        4: '待退费',
        5: '已退药',
        6: '已作废'
      };
      return stateMap[state] || state;
    },

    // 西药处方统计表格合计行
    getWesternDrugSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        const prop = column.property;
        if (['rxNo', 'bilgDeptId', 'bilgDrId', 'retFlag', 'state'].includes(prop)) {
          sums[index] = ' ';
          return;
        }

        const values = data.map(item => Number(item[prop]) || 0);
        if (!values.length) {
          sums[index] = '0';
          return;
        }

        const sum = values.reduce((acc, val) => acc + val, 0);
        sums[index] = this.formatAmount(sum);
      });

      return sums;
    },

    loadCurrentData() {
      switch (this.currentComponent) {
        case 'doctorStatistics':
          this.loadDoctorData();
          break;
        case 'pharmaceuticalStatistics':
          this.loadDrugData();
          break;
        case 'westernDrugPrescriptionStats':
          this.loadWesternDrugData();
          break;
        case 'finance_all':
          this.loadFinanceData();
          this.loadFinanceDataNoCondition();
          break;
      }
    },

    // 导航菜单点击事件
    handleMenuClick(data) {
      if (data.component) {
        this.currentComponent = data.component;
        this.$nextTick(() => {
          // 根据当前组件类型加载对应数据
          this.loadCurrentData();
        });
      }
    },

    // 加载医生统计数据
    async loadDoctorData() {
      try {
        const res = await getDoctorsStatistics({
          startTime: this.doctorTimeRange[0],
          endTime: this.doctorTimeRange[1],
        });
        if (res.code === 200) {
          this.doctorTableData = res.data || [];
        } else {
          this.$message.error(res.message || '获取医生统计数据失败');
        }
      } catch (error) {
        this.$message.error("系统异常: 请联系管理员");
      }
    },

    // 加载财务统计数据
    async loadFinanceData() {
      try {
        const params = {
          startTime: this.financeTimeRange ? this.financeTimeRange[0] : '',
          endTime: this.financeTimeRange ? this.financeTimeRange[1] : ''
        };
        const res = await getFinance(params);
        this.financeData = res.data || {};
      } catch (error) {
        console.error('获取财务数据失败:', error);
        this.$message.error('获取财务数据失败');
      }
    },

    // 加载财务统计数据
    async loadFinanceDataNoCondition() {
      try {
        const res = await getFinance();
        this.financeDataNoCondition = res.data || {};
      } catch (error) {
        console.error('获取财务数据失败:', error);
        this.$message.error('获取财务数据失败');
      }
    },

    // 加载药品统计数据
    async loadDrugData() {
      try {
        const res = await getDrugStatistics({
          startTime: this.drugTimeRange[0],
          endTime: this.drugTimeRange[1],
        });
        if (res.code === 200) {
          this.drugTableData = res.data || [];
        } else {
          this.$message.error(res.message || '获取药品统计数据失败');
        }
      } catch (error) {
        this.$message.error("系统异常: 请联系管理员");
      }
    },

    // 医生统计表格合计行
    getDoctorSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        const prop = column.property;
        if (['doctorId', 'doctorNmae'].includes(prop)) {
          sums[index] = ' ';
          return;
        }

        const values = data.map(item => Number(item[prop]) || 0);
        if (!values.length) {
          sums[index] = '0';
          return;
        }

        if (prop === 'mcProportion') {
          const avg = values.reduce((acc, val) => acc + val, 0) / values.length;
          sums[index] = avg.toFixed(2) + '%';
        } else if (prop.startsWith('avg')) {
          const avg = values.reduce((acc, val) => acc + val, 0) / values.length;
          sums[index] = avg.toFixed(2);
        } else {
          const sum = values.reduce((acc, val) => acc + val, 0);
          sums[index] = sum.toFixed(2);
        }
      });

      return sums;
    },

    // 药品表格行样式
    drugTableRowClassName({row}) {
      if (row.type === 1) {
        return 'success-row';
      } else if (row.type === 2) {
        return 'warning-row';
      }
      return '';
    },

    formatClassId(id) {
      const item = this.financeclassOptions.find(item => item.id === id)
      console.log(item, 'getgetgetget')
      return item.label;
    },

    // 格式化百分比
    formatPercentage(value) {
      if (value === null || value === undefined) return '0.00%';
      return Number(value).toFixed(2) + '%';
    },

    // 计算百分比
    calculatePercentage(amount, total) {
      if (!total || total === 0) return '0.00%';
      return ((amount / total) * 100).toFixed(2) + '%';
    },

    // 格式化药品类型
    formatDrugType(type) {
      const typeMap = {1: '西药', 2: '中药'};
      return typeMap[type] || type;
    },

    // 计算对象属性总和
    calculateTotal(obj) {
      return Object.values(obj).reduce((sum, value) => sum + (value || 0), 0);
    },
    getColumnWidth(label, prop, tableData) {
      console.log(tableData, 'tableDatatableData')
      const minWidth = 100;
      const padding = 30; // 增加边距缓冲
      const contentList = tableData.map(item => item?.[prop] ?? '');

      // 计算所有内容宽度（包括表头）
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度（使用Canvas）
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column, $index}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5); //加上一个文字长度
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
    safeGetMappedValue(col, row, type) {

      const hiddenProps = new Set([
        'usedfrquId', 'sdoseCnt', 'prdCnt', 'prdDays', 'medcWayId', 'tcmCnt',
        'selfProe', 'skintstRslt', 'remark', 'remarks', 'rxDosCnt',
      ]);

      if (hiddenProps.has(col.prop)) {
        return ''; // 直接返回空字符串，不显示
      }
      // 1. 检查数据有效性
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      // 2. 检查映射数组
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      // 3. 执行映射
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },
    /*表格合计列计算*/
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      // 需要计算的字段配置
      const calcFields = {
        'saleAmt': '合计金额',
        'reAmt': '退药金额',
        'purcAmt': '成本金额',
        'grossProfitRate': '毛利'
      };

      columns.forEach((column, index) => {
        // 第一列显示行号（留空）
        if (index === 0) {
          sums[index] = '';
          return;
        }

        // 第二列（剂量单位）显示"合计"文字
        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        // 只处理需要计算的字段
        if (calcFields[column.property]) {
          const total = data.reduce((sum, item) => {
            const value = parseFloat(item[column.property]) || 0;
            return sum + value;
          }, 0);

          // 如果是cnt列，显示为整数，否则保留两位小数
          sums[index] = column.property === 'cnt'
              ? Math.round(total).toString()
              : total.toFixed(2);
        } else {
          // 其他列显示占位符（与图片中的"一"一致）
          sums[index] = '';
        }
      });

      return sums;
    },
  }
}
</script>

<style scoped>

/* 利润卡片 */
.profit-card {
  height: 100%;
  border: none;
  border-radius: 8px;
}

.profit-card /deep/ .el-card__body {
  padding: 20px;
}

.card-content {
  display: flex;
  align-items: center;
}

.card-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  margin-right: 15px;
  font-size: 24px;
}

/* 收入卡片 */
.income-card {
  border-left: 4px solid #67C23A;
}

.income-card .card-icon {
  background: linear-gradient(135deg, #f0f9eb 0%, #e1f3d8 100%);
  color: #67C23A;
}

.income-value {
  color: #67C23A;
}

/* 支出卡片 */
.expense-card {
  border-left: 4px solid #F56C6C;
}

.expense-card .card-icon {
  background: linear-gradient(135deg, #fef0f0 0%, #fde2e2 100%);
  color: #F56C6C;
}

.expense-value {
  color: #F56C6C;
}

/* 毛利润卡片 */
.profit-sum-card {
  border-left: 4px solid #409EFF;
}

.profit-sum-card .card-icon {
  background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 100%);
  color: #409EFF;
}

.profit-positive {
  color: #67C23A;
}

.profit-negative {
  color: #F56C6C;
}

/* 毛利率卡片 */
.profit-rate-card {
  border-left: 4px solid #E6A23C;
}

.profit-rate-card .card-icon {
  background: linear-gradient(135deg, #fdf6ec 0%, #faecd8 100%);
  color: #E6A23C;
}

.profit-rate-value {
  color: #E6A23C;
}

/* 卡片文字样式 */
.card-text {
  flex: 1;
}

.card-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.card-value {
  font-size: 22px;
  font-weight: bold;
  line-height: 1.2;
}

@media (max-width: 768px) {
  .profit-cards-container .el-col {
    width: 100%;
    margin-bottom: 10px;
  }

  .card-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .card-value {
    font-size: 16px;
  }
}
/* 报表表格卡片 */
.report-table-card /deep/ .el-card__body {
  padding: 0;
}


.el-table /deep/ .income-section td {
  background-color: #f0f9eb !important;
  color: #67C23A !important;
  border-bottom: 2px solid #67C23A !important;
}

.el-table /deep/ .expense-section td {
  background-color: #fef0f0 !important;
  color: #F56C6C !important;
  border-bottom: 2px solid #F56C6C !important;
}


.el-table /deep/ .income-category td {
  color: #409EFF !important;
}

.el-table /deep/ .expense-category td {
  color: #F56C6C !important;
}

.el-table /deep/ .detail-item-row {
  font-size: 14px !important;
}

.el-table /deep/ .spacer-row td {
  height: 10px;
  border: none !important;
}

/* 金额单元格 */
.income-section-amount {
  color: #67C23A !important;
}

.expense-section-amount {
  color: #F56C6C !important;
}

.income-category-amount {
  color: #409EFF !important;
}

.expense-category-amount {
  color: #F56C6C !important;
}

.income-amount {
  color: #67C23A !important;
}

.expense-amount {
  color: #F56C6C !important;
}

/* 表格悬停效果 */
.el-table /deep/ tbody tr:hover > td {
  background-color: #f5f7fa !important;
}

/* 响应式调整 */
@media (max-width: 1600px) {
  .five-box-container {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
}

@media (max-width: 1200px) {
  .five-box-container {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .five-box-container {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(5, 1fr);
  }

  .data-row {
    padding: 6px 10px;
    min-height: 32px;
  }
}

/* 财务统计特定样式 */
.finance-horizontal-layout {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
}

.finance-section {
  height: 95%;
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  margin-bottom: 16px;
  border-radius: 8px;
  color: white;
  font-weight: 600;
}

.section-header i {
  font-size: 20px;
  margin-right: 10px;
}


.table-row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  min-height: 44px;
  transition: background-color 0.2s;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.table-row.header-row {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  font-weight: 600;
  color: #495057;
}

.table-row.category-row {
  background-color: #f0f7ff;
  font-weight: 600;
  color: #409eff;
}

.table-row.total-row {
  background-color: #e3f2fd;
  font-weight: 600;
}

.table-row.total-row:hover {
  background-color: #dbeafe;
}

.table-cell {
  padding: 12px;
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 44px;
  border-right: 1px solid #f0f0f0;
}

.table-cell:last-child {
  border-right: none;
}

.header-row .table-cell {
  justify-content: center;
  font-size: 14px;
}

.category-title {
  justify-content: flex-start;
  font-size: 14px;
  color: #409eff;
}

.sub-item {
  padding-left: 24px;
  color: #606266;
}

.amount-cell {
  justify-content: flex-end;
  font-weight: 500;
  color: #1890ff;
}

.amount-cell.total-amount {
  color: #f56c6c;
  font-size: 15px;
}

.percentage-cell {
  justify-content: center;
  color: #666;
  font-size: 13px;
}

/* 西药处方统计特定样式 */
.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 0 0 8px 8px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .pagination-container {
    padding: 8px;
  }

  .pagination-container .el-pagination__jump {
    display: none;
  }
}

/* 加载状态样式 */
.western-drug-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.dashboard-container {
  display: flex;
  height: 100%;
  background: #f5f7fa;
}

.sidebar {
  width: 10vw;
  background: white;
  border-right: 1px solid #e6e6e6;
  padding: 20px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
  background: #f5f7fa;
}

/* 报表容器样式 */
.report-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.report-icon {
  font-size: 24px;
  margin-right: 12px;
}

.header-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.report-table {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 树形菜单样式 */
.nav-tree {
  background: transparent;
  border: none;
}

.tree-node {
  display: flex;
  align-items: center;
  font-size: 14px;
  width: 100%;
  padding: 4px 0;
  justify-content: space-between;
}

.tree-icon {
  margin-right: 8px;
  color: #606266;
  font-size: 16px;
}

.badge {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 500;
}

.income-badge {
  background: #f0f9eb !important;
  color: #67c23a !important;
  border: 1px solid #e1f3d8;
}

.expense-badge {
  background: #fef0f0 !important;
  color: #f56c6c !important;
  border: 1px solid #fcd3d3;
}

.nav-tree :deep(.el-tree-node__content) {
  height: 44px;
  padding: 0 20px;
  margin: 2px 0;
  border-radius: 6px;
  transition: all 0.2s;
}

.nav-tree :deep(.el-tree-node__content:hover) {
  background-color: #f5f7fa;
}

.nav-tree :deep(.el-tree-node.is-current > .el-tree-node__content) {
  background: linear-gradient(135deg, #ecf5ff, #d9ecff);
  color: #409eff;
  font-weight: 500;
}

.nav-tree :deep(.el-tree-node.is-current .tree-icon) {
  color: #409eff;
}

.nav-tree :deep(.el-tree-node__label) {
  font-size: 14px;
  flex: 1;
}

.nav-tree :deep(.el-tree-node__children .el-tree-node__content) {
  padding-left: 40px;
}

.nav-tree :deep(.el-tree-node__children .el-tree-node__label) {
  font-size: 13px;
}

.nav-tree :deep(.el-tree-node__children .badge) {
  font-size: 10px;
  padding: 1px 4px;
}

.nav-tree :deep(.el-tree-node__children .el-tree-node.is-current > .el-tree-node__content) {
  background: linear-gradient(135deg, #f0f9ff, #e6f7ff);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .sidebar {
    width: 240px;
  }

  .header-title {
    font-size: 16px;
  }

  .section-header {
    padding: 12px 16px;
  }

  .table-cell {
    padding: 12px 8px;
    min-height: 44px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .dashboard-container {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #e6e6e6;
  }

  .content {
    height: calc(100vh - 200px);
    padding: 12px;
  }

  .report-header {
    flex-direction: column;
    gap: 12px;
    padding: 12px;
  }

  .header-title {
    justify-content: center;
  }

  .section-header {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .horizontal-table {
    overflow-x: auto;
  }

  .table-row {
    min-width: 400px;
  }
}

/* 滚动条样式 */
.content::-webkit-scrollbar {
  width: 6px;
}

.content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.finance-horizontal-layout::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.finance-horizontal-layout::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

/* 动画效果 */
.table-row {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 打印样式 */
@media print {
  .sidebar {
    display: none;
  }

  .report-header {
    background: #333 !important;
    color: white !important;
    -webkit-print-color-adjust: exact;
  }

  .horizontal-table {
    box-shadow: none !important;
    border: 1px solid #000 !important;
  }
}
</style>

<style>
/* 全局表格行样式 */
.success-row {
  background: #f0f9eb !important;
}

.warning-row {
  background: oldlace !important;
}

.success-row:hover td {
  background-color: #e1f3d8 !important;
}

.warning-row:hover td {
  background-color: #faecd8 !important;
}

/* Element UI 表格样式覆盖 */
.report-data-table .el-table {
  font-size: 13px;
}

.report-data-table .el-table th {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  color: #495057;
}

.report-data-table .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fafafa;
}
</style>